// Libs
import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import reduxThunk from 'redux-thunk'

// Reducers
import reducers from '../reducers';

// Middlewares
import notifyMiddleware from '../middlewares/notifyMiddleware'
import resetMiddleware from '../middlewares/resetMiddleware'

// Create store with middleware
const createStoreWithMiddleware = createStore(reducers, composeWithDevTools(
  applyMiddleware(reduxThunk, notifyMiddleware, resetMiddleware),
));

// Assign store
const store = createStoreWithMiddleware

export default store
